import { useDispatch } from 'react-redux';
import { SoapNotesStatuses } from '../../redux/API/ClientAPIHelpers/dataCollectionProperties';
import { DispatchProperties, useSelector } from '../../redux/store';
import { TEXT } from '../../shared/Helpers/colors';

import { Text } from '../../shared/uiComponents';
import { hours } from './Helpers/constants';
import { sortByTime } from './Helpers/functions';
import Session from './Session';
import { useScreenWidth } from '../../shared/Helpers/hooks';
import { goToNextDay, goToPreviousDay } from '../../redux/State/clientSlice/calendarHelperSlice';
import { useSwipe } from './hooks/useSwipe';

const DayView = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const showCompletedSession = useSelector((state) => state.calendarHelper.filterData.showCompleted);
	const showDraftsOnly = useSelector((state) => state.calendarHelper.filterData.showDraftsOnly);
	const events = useSelector((state) => state.calendar.events);
	const day = useSelector((state) => state.calendarHelper.day);
	const month = useSelector((state) => state.calendarHelper.month);

	const swipeHandlers = useSwipe({
		onSwipeLeft: () => {
			if (isMobile) {
				dispatch(goToNextDay());
			}
		},
		onSwipeRight: () => {
			if (isMobile) {
				dispatch(goToPreviousDay());
			}
		},
	});

	return (
		<div className="dayView" {...(isMobile ? swipeHandlers : {})}>
			{hours.map((hour, hourIndex) => (
				<div className="row" key={hourIndex}>
					<div style={{ position: 'relative', minWidth: '80px' }}>
						<Text title={hour} color={TEXT.TERTIARY} type="psm" />
					</div>
					<div style={{ position: 'relative', width: '100%' }}>
						{events &&
							events.length > 0 &&
							[...events]
								.sort((a, b) => sortByTime({ a, b }))
								.filter((x) =>
									showCompletedSession ? x.isCompleted && x.reportStatus?.status === SoapNotesStatuses.submitted : true,
								)
								.filter((x) => (showDraftsOnly ? x.reportStatus?.status === SoapNotesStatuses.draft : true))
								.filter(
									(x) =>
										new Date(x.startTime).getDate() === day &&
										new Date(x.startTime).getMonth() === month &&
										new Date(x.startTime).getUTCHours() === hourIndex + 5,
								)
								.map((res) => <Session key={res.id} event={res} />)}
						<div className="dashedLine" />
					</div>
				</div>
			))}
		</div>
	);
};

export default DayView;
